import { Component, createEffect, Show } from "solid-js";
import { createStore } from "solid-js/store";
import { SelectEntity } from "./select-entity";
import { ModalWindow } from "./modal-window";
import { ListItem } from "../../types";

type Props ={
    label?: string;
    initialValue: ListItem;
    onClearClicked?: () => void;
    onItemSelected: (item: ListItem) => void;
    setInstance?: (inst: ISelectEntityModalInstance) => void;
}
export interface ISelectEntityModalInstance {
    clear: () => void;
}

export const SelectEntityModal : Component<Props> = (props) =>{
    type FieldState = {
        visible: boolean; item?: ListItem;
    }
    const [state, setState] = createStore<FieldState>({
        visible: false,
        item: props.initialValue
    });
    const open = () => setState("visible", true);
    const close = () => setState("visible", false);
    const onSearchClicked = (e: Event) => {
        e.preventDefault();
        open();
    }
    const onClearClicked = (e: Event) => {
        e.preventDefault();
        setState("item", { Text: "", Value: "" });
        if (props.onClearClicked) props.onClearClicked();
    }
    const onClose = () => close();
    const onSelected = (item: ListItem) => {
        close();
        setState("item", item);
        props.onItemSelected(item);
    }
    createEffect(() => !!props.initialValue ? setState("item", props.initialValue) : setState("item", undefined));
    if (props.setInstance) {
        props.setInstance({
            clear: () => {
                setState("item", { Text: "", Value: "" });
            }
        });
    }
    return (
        <>
            <div>
                <input type="text" value={state.item?.Text} disabled class="form-control" style="display: inline-block; width: 300px;" />
                <button style="display: inline-block; margin-left: 10px;" class="btn btn-default" onClick={onClearClicked}>Clear</button>
                <button class="btn btn-primary"style="display: inline-block; margin-left: 10px;" onClick={onSearchClicked}>Search</button>
            </div>
            <ModalWindow title="Select an entity ..." visible={state.visible} onClose={onClose}>
                <SelectEntity onSelected={onSelected} onClear={onClose} />
            </ModalWindow>
        </>
    )
}